export const BASE_URLS = {
  development: "https://api.ottenndev.com/dev",
  production: "https://api.ottenndev.com",
};

// Function to get and set the current environment
export const getEnvironment = () => {
  return localStorage.getItem("selectedEnvironment") || "production";
};

export const setEnvironment = (env) => {
  localStorage.setItem("selectedEnvironment", env);
};

export const getCurrentBaseURL = () => {
  return BASE_URLS[getEnvironment()];
};

const getRequestUrl = (url) => {
  return `${getCurrentBaseURL()}/${url}`;
};

export const userToken = localStorage.getItem("userToken");

export const Fetch = async (url, options) => {
  try {
    if (!userToken && url !== "auth/admin/login") {
      window.location.href = "/login";
      return;
    }

    options.headers = options.headers || {
      "Content-Type": "application/json",
      Authorization: userToken,
    };

    const response = await fetch(getRequestUrl(url), options);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Request failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message);

    if (error.message === "Authorization token expired.") {
      // Redirect to the login page
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");
      window.location.href = "/login";
    } else {
      throw new Error(error.message);
    }
  }
};
